import React, { createContext, useContext, useState } from 'react';
import ItineraryProvider from './ItineraryProvider';
import { ItineraryFeeTypeProvider } from './ItineraryFeeTypeProvider';
import { useShoppingCartRequestEffect } from 'clientState/providers/ShoppingBundleProvider/ShoppingCartRequestHooks';

const ItinerarySelectionContext = createContext();

const ShoppingCartRequestProvider = ({ children }) => {
  useShoppingCartRequestEffect({});
  return children;
};

const ItinerarySelectionProvider = ({ itineraryFromUrl, children }) => {
  const [{ itinerary, position }, setItineraryInfo] = useState({
    itinerary: itineraryFromUrl,
  });
  return (
    <ItinerarySelectionContext.Provider value={setItineraryInfo}>
      <ItineraryFeeTypeProvider>
        <ItineraryProvider itinerary={itinerary} position={position}>
          <ShoppingCartRequestProvider>{children}</ShoppingCartRequestProvider>
        </ItineraryProvider>
      </ItineraryFeeTypeProvider>
    </ItinerarySelectionContext.Provider>
  );
};

export const useItinerarySelection = () =>
  useContext(ItinerarySelectionContext);

export default ItinerarySelectionProvider;
